var _rect, _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStrokeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 16.9708,
    height: 16.9708,
    rx: 2,
    transform: "rotate(-45 18 24)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 19,
    height: 26
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 19,
    height: 26,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 6,
    y: 24,
    width: 16.9708,
    height: 16.9708,
    rx: 2,
    transform: "rotate(-45 6 24)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTgiIHk9IjI0IiB3aWR0aD0iMTYuOTcwOCIgaGVpZ2h0PSIxNi45NzA4IiByeD0iMiIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDE4IDI0KSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iNSIgeT0iMTEiIHdpZHRoPSIxOSIgaGVpZ2h0PSIyNiI+CjxyZWN0IHg9IjUiIHk9IjExIiB3aWR0aD0iMTkiIGhlaWdodD0iMjYiIGZpbGw9IiNDNEM0QzQiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxyZWN0IG9wYWNpdHk9IjAuNSIgeD0iNiIgeT0iMjQiIHdpZHRoPSIxNi45NzA4IiBoZWlnaHQ9IjE2Ljk3MDgiIHJ4PSIyIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNiAyNCkiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgEmptyStrokeinline as ReactComponent };